<template>
    <div class="header">
        <div class="header_left">
            <div class="toggleIcon" :class="isShows ? 'el-icon-s-fold' : 'el-icon-s-unfold'" @click="getClick"></div>
            <el-breadcrumb separator-class="el-icon-arrow-right">
                <el-breadcrumb-item >首页</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentRoute.parentName }}</el-breadcrumb-item>
                <el-breadcrumb-item>{{ currentRoute.name }}</el-breadcrumb-item>
            </el-breadcrumb>
        </div>
        <div class="header_right">

            <el-dropdown szie="mini" trigger="click">
                <span class="el-dropdown-link">
                    <el-avatar icon="el-icon-user-solid" :size="30" fit="fit" :src="imgUrl"></el-avatar> <span class="nickname">{{nickName}}</span>
                </span>
                <el-dropdown-menu slot="dropdown">
                    <el-dropdown-item @click.native="getOut">退出登陆</el-dropdown-item>
                    <!-- <el-dropdown-item></el-dropdown-item> -->
                </el-dropdown-menu>
            </el-dropdown>
        </div>
    </div>
</template>

<script>
import { store, mutations } from '@/store/store.js'
import mins from './mins'
import fetch from '@/api/fetch.js'
export default {
    name: 'Header',
    mixins: [mins],
    data() {
        return {
            imgUrl: '',
            nickName: ''
        };
    },
    watch: {
        $route() {
            this.changeRouter()
        }
    },
    created() {
        this.nickName = sessionStorage.getItem('nickname')
        this.changeRouter()
    },
    methods: {
        changeStores: mutations.changeStore,
        getClick() {
            this.changeStores()
        },
        getOut() {
            fetch.signout(localStorage.getItem("token")).then(res => {
                if (res.code == '0') {
                    localStorage.removeItem("token");
                    this.$router.push('/login')
                } else {
                    this.$message.error(res.msg)
                }
            })
        }
    },
    computed: {
        isShows() {
            return store.isShow
        }
    },
};
</script>

<style lang="scss" scoped>
.header {
    height: 40px;
    line-height: 40px;
    background-color: #fff;
    padding: 0 15px;
    box-sizing: border-box;
    display: flex;
    justify-content: space-between;
    align-items: center;
    box-shadow: 0 2px 4px rgba(0, 0, 0, 0.12), 0 0 6px rgba(0, 0, 0, 0.04);

    .header_left {
        display: flex;
        justify-content: flex-start;
        align-items: center;
        width: 75%;
        .toggleIcon {
            margin-right: 10px;
            cursor: pointer;
        }
    }
    .header_right {
        height: 100%;
        width: 25%;
        display: flex;
        justify-content: flex-end;
        align-items: center;
    }
}
/deep/.el-dropdown-link {
    display: flex;
    justify-content: space-between;
    align-items: center;
    cursor: pointer;
    .el-avatar {
        margin-right: 10px;
    }
    .nickname {
        max-width: 180px;
        overflow: hidden;
        text-overflow: ellipsis;
        white-space: nowrap;
    }
}
.el-icon-arrow-down {
    font-size: 12px;
}
</style>